import {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {TextField, Grid} from "@material-ui/core";
import {DeliveryDetails} from 'shared/FormComponents';
import {ValidationContext} from 'shared/useValidation';

export default function Form() {
  const [t] = useTranslation();
  const {getInputProps} = useContext(ValidationContext);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextField
          variant="outlined"
          fullWidth
          label={t("beneficiary.beneficiaryName")}
          required
          {...getInputProps("beneficiaryName")}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          variant="outlined"
          fullWidth
          label={t("beneficiary.beneficiaryNameSupplement")}
          helperText={t("beneficiary.nameSupplementHelper")}
          {...getInputProps("beneficiaryNameSupplement")}
        />
      </Grid>
      <DeliveryDetails hideEInvoice/>
    </Grid>
  );
}
